angular.module('unergie.main')
.directive('salesTunnelSummary', (MetaWatcher, BoFeaturesService, AuthService) => ({
    restrict: 'E',
    scope: {
        draft: '=',
        prm: '=',
        landscape: '=',
        readings: '=',
        user: '=',
        draftState: '=',
        subscriptionPrice: '=',
        checks: '=',
        validated: '=',
        disableContractEdition: '=',
    },
    templateUrl: '/states/salesTunnelV2/component/salesTunnelSummary.html',
    link($scope) {
        $scope.saveDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT')
        $scope.isAdmin = () => AuthService.userHasGroup(['data-admin', 'data-reader'])
        $scope.showIdContract = BoFeaturesService.isFeatureOn('showIdContract')

        $scope.isOrderPreparationValid = function () {
            const VALIDATOR_NAMES = [
                // RESIDENCE
                'isAMoveDefined',

                // PRM
                'isPrmValid',
                'isPrmEligible',
                'isMaxPowerDefined',
                'isIdPCalendarDefined',
                'isPrmSearchHintValid',

                 // QUOTATION
                'isLandscapeValid',
                'isPromoCodeValid',
                'isPreferredPaymentDayValid',
            ]
            return _.every(_.map(_.pick($scope.validated, VALIDATOR_NAMES), (val) => { return _.isObject(val) ? val.value : val }))
        }

        $scope.isClientInfoValid = function () {
            const VALIDATOR_NAMES = [
                 // NOMINAL
                'isCivDefined',
                'isGivennameDefined',
                'isSnDefined',
                'isSecondNameWellDefined',
                'isMailDefined',
                'isPhoneDefined',
                'isBirthDateDefined',
                'isAcceptContactsDefined',
            ]
            return _.every(_.map(_.pick($scope.validated, VALIDATOR_NAMES), (val) => { return _.isObject(val) ? val.value : val }))
        }

        $scope.isGRDValid = function () {
            const VALIDATOR_NAMES = [
                // GRD
                'isInterventionTypeValid',
                'isBypassRetractationDefined',
                'isPrimaryResidenceDefined',
                'isHeatingDefined',
                'isSelfReportValid',
                'isConsuelValid',
            ]
            return _.every(_.map(_.pick($scope.validated, VALIDATOR_NAMES), (val) => { return _.isObject(val) ? val.value : val }))
        }
    },
}))
